const en = {
  // ============ NAV ============
  nav_features: "Features",
  nav_how: "How it works",
  nav_pricing: "Pricing",
  nav_portals: "Portals",
  nav_signin: "Sign in",
  nav_signup: "Get started",
  nav_dashboard: "Open dashboard",

  // ============ HERO ============
  hero_badge: "Trusted by 12,000+ families worldwide",
  hero_line1: "The world's most",
  hero_line2: "intelligent",
  hero_line3: "safety network.",
  hero_sub:
    "Guardian360 turns a single QR code into a lifeline — instant emergency contact, live GPS, AI response, and community protection. For you, your kids, your car, your pet, your everything.",
  cta_protect: "Protect me now",
  cta_how: "See how it works",
  ok_no_cc: "No credit card",
  ok_gdpr: "GDPR compliant",
  ok_offline: "Works offline (via QR)",
  hero_alert_title: "Maya reached school safely",
  hero_alert_meta: "2 mins ago · Zone: safe",
  hero_alert_label: "Live alert",
  hero_scan_title: "Vehicle KA-01-AB-4231",
  hero_scan_meta: "Someone contacted you",
  hero_scan_label: "QR scanned",
  hero_scroll: "Scroll to explore",

  // ============ LIVE TICKER ============
  ticker_live: "LIVE",
  ticker_sos: "SOS resolved this week",
  ticker_scans: "QR scans processed",
  ticker_reunited: "families reunited via Lost & Found",
  ticker_cities: "cities live",
  ticker_uptime: "uptime",

  // ============ CORE CAPABILITIES ============
  cap_kicker: "Core capabilities",
  cap_title: "Four capabilities. One QR.",
  cap_sub: "Every Guardian sticker unlocks a full safety stack. No hardware, no batteries — works even offline.",
  cap_1_tag: "SOS Alert",
  cap_1_title: "1-tap emergency broadcast",
  cap_1_desc: "Live location, photo + video streams to family, volunteers, police and ambulance in real time.",
  cap_2_tag: "Find Location",
  cap_2_title: "Live family radar",
  cap_2_desc: "See loved ones on a live map with battery, speed and safe-zone alerts.",
  cap_3_tag: "Route Tracking",
  cap_3_title: "Trip + rash-drive alerts",
  cap_3_desc: "Over-speed, rash-driving and black-spot warnings — before accidents happen.",
  cap_4_tag: "Crash Detection",
  cap_4_title: "Auto emergency response",
  cap_4_desc: "Detects hard impacts and auto-dispatches nearest responder + SMS to next of kin.",
  cap_explore: "Explore",

  // ============ STATS ============
  stat_families: "families protected",
  stat_scans: "QR scans processed",
  stat_sos: "SOS resolved / week",
  stat_sla: "responder SLA",

  // ============ CATEGORIES ============
  cat_kicker: "Who we protect",
  cat_title: "A Guardian for every situation.",
  cat_sub: "From a child's backpack to a corporate fleet — one platform, tailored profiles.",
  cat_get_qr: "Get QR",
  cat_vehicle: "Vehicle Safety",
  cat_child: "Child Safety",
  cat_family: "Family Safety",
  cat_senior: "Senior Care",
  cat_pet: "Pet Safety",
  cat_lostfound: "Lost & Found",
  cat_corporate: "Corporate & Fleet",
  cat_emergency: "Emergency Services",

  // ============ HOW IT WORKS ============
  steps_kicker: "How it works",
  steps_title: "Three steps. Lifetime peace of mind.",
  steps_sub: "Setup once. Guardian360 quietly watches over you and your loved ones — until the moment you need it.",
  steps_cta: "Start protecting",
  step_1_t: "Create your Guardian",
  step_1_d: "Sign up in 30 seconds. Add emergency contacts, medical info, and photo.",
  step_2_t: "Print your QR",
  step_2_d: "Download high-res QR stickers for wallet, keychain, car, pet collar, luggage.",
  step_3_t: "Live protected",
  step_3_d: "Anyone who scans reaches you. Trigger SOS anytime with one tap.",

  // ============ MODULES ============
  fs_kicker: "The Guardian Stack",
  fs_title: "Everything you need to feel safer — in one ecosystem.",
  fs_sub: "14 modules. One account. Built for real emergencies, not just marketing.",
  mod_1_t: "Smart Digital ID",
  mod_1_d: "One scan reveals emergency contacts, medical info & GPS ping — no app needed for the finder.",
  mod_2_t: "1-Tap Emergency SOS",
  mod_2_d: "Instantly broadcasts your live location to volunteers, family, and nearby responders.",
  mod_3_t: "Family Radar",
  mod_3_d: "See loved ones on a live map. Get alerts when a child leaves a safe zone.",
  mod_4_t: "Vehicle QR",
  mod_4_d: "Blocked in? Anyone scans the sticker on your car and reaches you privately.",
  mod_5_t: "Lost & Found",
  mod_5_d: "Attach QR tags to luggage, keys, pets — get instant notifications when scanned.",
  mod_6_t: "Guardian AI",
  mod_6_d: "Certified emergency guidance 24/7. Medical, fire, road — you're never alone.",
  mod_7_t: "Community Watch",
  mod_7_d: "Anonymous incident feed + heatmap. Know what's happening in your neighborhood.",
  mod_8_t: "Privacy-First",
  mod_8_d: "You choose exactly what a scanner sees. Full audit log of every scan.",

  // ============ APP DOWNLOAD ============
  app_kicker: "Mobile app",
  app_title: "The app that stays awake so you can sleep.",
  app_sub: "SOS button, live family map and Guardian AI in your pocket. iOS + Android. Works with the same account as web.",
  app_get_google: "Get it on",
  app_google: "Google Play",
  app_get_apple: "Download on the",
  app_apple: "App Store",
  app_coming: "Coming soon",
  app_rating: "App rating",
  app_downloads: "Downloads",
  app_console: "Guardian Console",
  app_greet: "Hi, Aarav.",
  app_live_sos: "Live SOS",
  app_responders: "2 responders en route",

  // ============ PORTALS ============
  portals_kicker: "Ecosystem",
  portals_title: "Purpose-built portals for every responder.",
  portal_role: "Portal",

  // ============ TESTIMONIALS ============
  testi_kicker: "Real stories",
  testi_title: "People we've helped, in their own words.",
  testi_1_name: "Imran Ali", testi_1_city: "Lucknow",
  testi_1_quote: "A stranger scanned my car's Guardian QR after I fainted in a jam. My wife got a call and live map within 15 seconds. It literally saved me.",
  testi_2_name: "Swati Singh", testi_2_city: "Patna",
  testi_2_quote: "My dog Bruno went missing at the park. Someone scanned his collar tag — my phone rang before I finished my chai. Reunited in 12 minutes.",
  testi_3_name: "Rajat Patel", testi_3_city: "Ahmedabad",
  testi_3_quote: "The AI Assistant walked my mother-in-law through a diabetic emergency at 2 AM until the ambulance arrived. Cannot recommend enough.",
  testi_4_name: "Pooja Iyer", testi_4_city: "Bengaluru",
  testi_4_quote: "Left my laptop bag in an Uber. Driver scanned the tag, called back in 4 minutes. I've paid ₹399 for peace of mind — it paid for itself in one ride.",

  // ============ CERTIFICATIONS ============
  cert_kicker: "Trusted & certified",
  cert_title: "Enterprise-grade compliance out of the box.",
  cert_audit: "Audited quarterly",

  // ============ PRICING ============
  pricing_kicker: "Pricing",
  pricing_title: "Safety shouldn't be a luxury.",
  pricing_sub: "Start free. Upgrade when your family grows.",
  tier_free: "Guardian Free",
  tier_free_tag: "Forever",
  tier_free_cta: "Start free",
  tier_free_1: "Up to 3 QR profiles",
  tier_free_2: "Emergency SOS",
  tier_free_3: "Community alerts",
  tier_free_4: "Guardian AI (10/day)",
  tier_plus: "Guardian Plus",
  tier_plus_tag: "/mo",
  tier_plus_cta: "Go Plus",
  tier_plus_popular: "Most Popular",
  tier_plus_1: "Unlimited QR profiles",
  tier_plus_2: "Family radar (5 members)",
  tier_plus_3: "Unlimited Guardian AI",
  tier_plus_4: "Scan analytics",
  tier_plus_5: "Priority responders",
  tier_corp: "Guardian Corporate",
  tier_corp_price: "Custom",
  tier_corp_tag: "Enterprise",
  tier_corp_cta: "Talk to sales",
  tier_corp_1: "Fleet & workforce QR",
  tier_corp_2: "Admin dashboard",
  tier_corp_3: "SSO + audit logs",
  tier_corp_4: "Dedicated support",

  // ============ FAQ ============
  faq_kicker: "FAQ",
  faq_title: "Everything you might ask.",
  faq_1_q: "What exactly is a Guardian QR?",
  faq_1_a: "It's a personal, private QR sticker. When someone scans it (with any phone camera — no app needed), they see the emergency profile you chose to expose and can reach you or your family instantly.",
  faq_2_q: "How is the SOS button different from just calling 112?",
  faq_2_a: "SOS broadcasts your live GPS + category to every registered responder within radius plus your family — in parallel. If nobody accepts within 60 seconds, we fall back to SMS with a Google Maps link (works even without internet on their side).",
  faq_3_q: "Is my data safe? What does a scanner actually see?",
  faq_3_a: "You control every field — name, medical notes, contacts — per QR. Nothing else is exposed. Every scan is timestamped and logged for you. We are GDPR-aligned and never sell data.",
  faq_4_q: "Does Guardian360 work outside India?",
  faq_4_a: "Yes. The web app + PWA + native app work worldwide. Emergency numbers (112/911/108) are shown based on device locale. SMS fallback works on any E.164 phone number.",
  faq_5_q: "How do you make money?",
  faq_5_a: "The core safety features are free forever. Guardian Plus (₹399/mo) unlocks unlimited profiles, family radar and AI. Corporate plans are per-seat for fleets and enterprises.",

  // ============ CTA ============
  bigcta_kicker: "Get started · 30 seconds",
  bigcta_title: "Your loved ones deserve Guardian360.",
  bigcta_sub: "Join 12,000+ families already protected by the smart QR safety ecosystem.",
  bigcta_btn: "Create your Guardian",
  bigcta_sales: "Talk to sales",

  // ============ FOOTER ============
  footer_desc: "The world's most intelligent QR-powered safety ecosystem. Made for humans, by humans.",
  footer_h_product: "Product",
  footer_h_portals: "Portals",
  footer_h_company: "Company",
  footer_h_legal: "Legal",
  footer_l_features: "Features",
  footer_l_how: "How it works",
  footer_l_pricing: "Pricing",
  footer_l_mobile: "Mobile app",
  footer_l_volunteer: "Volunteer",
  footer_l_police: "Police",
  footer_l_hospital: "Hospital",
  footer_l_corporate: "Corporate",
  footer_l_about: "About",
  footer_l_blog: "Blog",
  footer_l_careers: "Careers",
  footer_l_contact: "Contact",
  footer_l_privacy: "Privacy",
  footer_l_terms: "Terms",
  footer_l_security: "Security",
  footer_l_gdpr: "GDPR",
  footer_rights: "All rights reserved.",

  // ============ AUTH ============
  login_title: "Welcome back.",
  login_sub: "Sign in to your Guardian360 account.",
  login_email: "Email",
  login_password: "Password",
  login_submit: "Sign in",
  login_switch: "New to Guardian360?",
  login_switch_link: "Create an account",
  register_title: "Create your Guardian.",
  register_sub: "Takes 30 seconds. No credit card.",
  register_name: "Full name",
  register_phone: "Phone (optional)",
  register_submit: "Create Guardian account",
  register_switch: "Already have an account?",
  register_switch_link: "Sign in",

  // ============ SIDEBAR ============
  side_overview: "Overview",
  side_qr: "My QR Codes",
  side_sos: "Emergency SOS",
  side_family: "Family",
  side_vehicle: "Vehicles",
  side_lostfound: "Lost & Found",
  side_community: "Community",
  side_ai: "Guardian AI",
  side_admin: "Admin Console",
  side_responder: "Responder Portal",
  side_signout: "Sign out",
  side_light: "Light",
  side_dark: "Dark",
};
export default en;
